var render = function (_h,_vm) {var _c=_vm._c;return _c('transaction-view',{attrs:{"transaction":_vm.props.transaction}},[_c('div',[_vm._v(_vm._s(_vm.parent.$t("Deposit"))+" ("+_vm._s(_vm.parent.$t("Credit Card"))+")")])])}
var staticRenderFns = []

export { render, staticRenderFns }